<ng-content select="eui-app-sidebar-menu"></ng-content>
